import { HttpClientModule } from '@angular/common/http';
import { ModuleWithProviders, NgModule, Provider } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { PANEL_REPOSITORY } from './repositories/IPanel.repository';
import { PanelRepository } from './repositories/panel.repository';
import { PANEL_SERVICE } from './services/IPanel.service';
import { PanelService } from './services/panel.service';
import { PanelEffects } from './state/panel.effects';
import { panelReducer } from './state/panel.reducer';
import { PANEL_STORE_KEY } from './state/panel.selectors';
import { PanelStore } from './state/panel.store';

interface ModuleOptionsInterface {
  providers: Provider[];
}

@NgModule({
  declarations: [],
  imports: [
    HttpClientModule,
    StoreModule.forFeature(PANEL_STORE_KEY, panelReducer),
    EffectsModule.forFeature([PanelEffects]),
  ],
  exports: [],
})
export class PanelCoreModule {
  static forRoot(
    config?: ModuleOptionsInterface
  ): ModuleWithProviders<PanelCoreModule> {
    return {
      ngModule: PanelCoreModule,
      providers: [
        { provide: PANEL_SERVICE, useClass: PanelService },
        { provide: PANEL_REPOSITORY, useClass: PanelRepository },
        ...(config?.providers || []),
        PanelStore,
      ],
    };
  }
}
